var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.8 9.689V8.267C7.8 5.913 8.5 4 12 4s4.2 1.913 4.2 4.267v1.422M12 16.622c.464 0 .91-.187 1.237-.52.328-.334.513-.786.513-1.258 0-.471-.185-.923-.513-1.257a1.736 1.736 0 0 0-1.237-.52c-.464 0-.91.187-1.238.52a1.792 1.792 0 0 0-.512 1.257c0 .472.184.924.512 1.258.329.333.774.52 1.238.52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.5 19.999h-7c-2.8 0-3.5-.711-3.5-3.556v-3.2c0-2.844.7-3.556 3.5-3.556h7c2.8 0 3.5.712 3.5 3.556v3.2C19 19.288 18.3 20 15.5 20Z"
  })));
};
export default SvgLock;